var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-button"},[_c('toggle-switch',{staticClass:"switch-button__toggle",attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}}),_c('span',{staticClass:"switch-button__label"},[_vm._v(_vm._s(_vm.$t(_vm.label)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }